import { SECOND_ATTEMPT_BULK_INVALIDATION_MODAL } from '../../actionTypes/reading/apiActionTypes';

export const initialState = {
    isSecondAttemptBulkInvalidationModalShown: false,
    studentInfo: null,
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SECOND_ATTEMPT_BULK_INVALIDATION_MODAL.SHOW:
            return {
                ...state,
                isSecondAttemptBulkInvalidationModalShown: true,
                studentInfo: action.studentInfo,
            };
        case SECOND_ATTEMPT_BULK_INVALIDATION_MODAL.HIDE:
            return {
                ...state,
                isSecondAttemptBulkInvalidationModalShown: false,
                studentInfo: action.studentInfo,
            };
        default:
            return state;
    }
};

const isSecondAttemptBulkInvalidationModalShown = state =>
    state.isSecondAttemptBulkInvalidationModalShown;
const getStudentInfoForSecondAttemptBulkInvalidation = state => state.studentInfo;

export const selectors = {
    isSecondAttemptBulkInvalidationModalShown,
    getStudentInfoForSecondAttemptBulkInvalidation,
};
